module.exports = __webpack_public_path__ + "static/media/image-3.79a1b1cc.jpg";